/* global homeUrl */

/**
 * HashNav
 * ======================================
 * - add active menu class for section in viewport
 * - homeUrl is used with Wordpress absolute links
 */

import { debounce } from '../utils/debounce'

const ENABLED = window.outerWidth < 768

const ITEMSCLASS = '.js-hashnav a'
const ACTIVECLASS = 'is-active'
const FIRSTACTIVE = false
const LASTACTIVE = true
const HOMEURL = typeof homeUrl === 'undefined' ? false : homeUrl

class HashNav {
	isEnabled = () => ENABLED

	constructor() {
		if (this.isEnabled()) {
			return false
		}

		this.elements = document.querySelectorAll(ITEMSCLASS)
		this.first = this.elements[0]
		this.last = this.elements[this.elements.length - 1]
		this.start = 0
		this.offset = window.innerHeight / 2

		document.addEventListener('scroll', debounce(this.scrollHandler, 10), false)

		this.scrollHandler()
	}

	scrollHandler = () => {
		this.elements.forEach(el => {
			let href = el.getAttribute('href')

			if (href.match('#') && href !== '#') {
				if (HOMEURL) {
					href = href.replace(HOMEURL + '/', '').replace(HOMEURL, '')
				}

				const target = document.querySelector(href)

				if (target) {
					const top = window.pageYOffset || document.documentElement.scrollTop
					this.classMagic(top, target, el)
				}
			}
		})
	}

	classMagic = (top, target, nav) => {
		if (top + window.innerHeight === document.documentElement.scrollHeight) {
			this.resetClass()

			if (LASTACTIVE) {
				this.last.classList.add(ACTIVECLASS)
			}
		} else if (top < this.offset) {
			this.resetClass()

			if (FIRSTACTIVE) {
				this.first.classList.add(ACTIVECLASS)
			}
		} else if (target.offsetTop - this.offset <= top && top > this.start) {
			this.resetClass()

			nav.classList.add(ACTIVECLASS)
		} else {
			nav.classList.remove(ACTIVECLASS)
		}
	}

	resetClass = () => {
		this.elements.forEach(el => {
			el.classList.remove(ACTIVECLASS)
		})
	}
}

new HashNav()
